import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { installNativeSelectSort, patchMultiSelectDropdownSort } from './app/shared/combo-sort/combo-sort';

if (environment.production) {
  enableProdMode();
}

// Todos os combos do sistema em ordem A-Z (exceções: data-no-sort / noSort / [sortOptions]="false")
patchMultiSelectDropdownSort();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => installNativeSelectSort())
  .catch((err) => console.error(err));
